// extracted by mini-css-extract-plugin
export var videoWrapper = "rich-text-renderer-module--video-wrapper--3wvKz";